var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1DownLeftArrowC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.93 28.36v17.85L50.14 23 53 25.86 29.79 49.07h17.85L51.57 53H23V24.43l3.93 3.93z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Down-left_arrow_C.50784730.svg";
export { SvgJ1DownLeftArrowC as ReactComponent };